"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const svgs_1 = require("@@/assets/svgs");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
function default_1({ has_like, changeLikeStateFn, maxWidth768, }) {
    return ((0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: {
            position: 'absolute',
            top: '2px',
            right: '4px',
            p: '4px',
            '&:hover': {
                bgcolor: maxWidth768 ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
            },
            zIndex: 20,
        }, onClick: e => {
            e.stopPropagation();
            e.preventDefault();
            changeLikeStateFn();
        } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.LikeHeartOutlinedSvg, { css: {
                path: {
                    transition: 'all 0.15s ease',
                    fill: has_like ? '#EB5757' : 'black',
                    fillOpacity: has_like ? 1 : 0.3,
                    strokeWidth: has_like ? 0 : 1.5,
                },
            } }) })));
}
exports.default = default_1;
